import React, { useEffect, createElement } from 'react';
import { Accordion } from './components/Accordion';
import { SalesPopup } from './components/SalesPopup';
import { CountdownTimer } from './components/CountdownTimer';
import { CheckCircle2, XCircle, Star, Settings, FileText, Zap, BookOpen, AlertTriangle, ArrowRight } from 'lucide-react';
const CHECKOUT_LINK = 'https://checkout.ebookpoint.shop/cart/49257833464060:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/eZMqGDhTqyngSpBeCtrKSv/ChatGPT_Image_Jul_6,_2026,_09_31_47_PM.png';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1252242806993118');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  const handleBuyClick = () => {
    window.location.href = CHECKOUT_LINK;
  };
  const scrollToOffer = () => {
    const el = document.getElementById('compra');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className="min-h-screen bg-white text-gray-900 font-sans relative" data-id="element-0">
      {/* Background with blurred football pitch */}
      <div className="fixed inset-0 z-0 opacity-10 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1518605368461-1e1e38ce151d?q=80&w=2074&auto=format&fit=crop")',
      filter: 'blur(6px)'
    }} data-id="element-1" />

      {/* Content Overlay */}
      <div className="relative z-10 max-w-3xl mx-auto px-4 py-8 md:py-12" data-id="element-2">
        {/* HERO SECTION */}
        <header className="text-center mb-10" data-id="element-3">
          <h1 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-4 leading-snug uppercase tracking-tight" data-id="element-4">
            <span className="text-green-700" data-id="element-5">Conviertete en el pivote</span> que
            tu equipo necesita cuando el partido se pone dificil
          </h1>

          <button type="button" onClick={scrollToOffer} aria-label="Ver la oferta y comprar El Manual del Pivote Moderno" className="block w-[85%] mx-auto relative rounded-xl overflow-hidden shadow-xl mb-6 border-2 border-green-600/30 cursor-pointer transform transition hover:scale-[1.01]" data-id="element-6">
            <img src={MAIN_IMAGE} alt="El Manual del Pivote Moderno" className="w-full h-auto object-cover" data-id="element-7" />
          </button>

          <h2 className="text-base md:text-lg font-semibold text-gray-700 mb-6 bg-green-50 px-4 py-3 rounded-lg border border-green-200 leading-snug" data-id="element-8">
            Guía paso a paso para entender el rol del pivote: posicionamiento,
            salida de balón, físico y prevención de lesiones.
          </h2>

          <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-9">
            <div className="flex items-center bg-green-50 border border-green-300 px-3 py-1.5 rounded-full" data-id="element-10">
              <FileText className="w-4 h-4 text-green-700 mr-1.5" data-id="element-11" />
              <span className="font-bold text-sm text-green-800" data-id="element-12">100% PDF</span>
            </div>
            <div className="flex items-center bg-green-50 border border-green-300 px-3 py-1.5 rounded-full" data-id="element-13">
              <Zap className="w-4 h-4 text-green-700 mr-1.5" data-id="element-14" />
              <span className="font-bold text-sm text-green-800" data-id="element-15">
                Entrega Inmediata
              </span>
            </div>
            <div className="flex items-center bg-green-50 border border-green-300 px-3 py-1.5 rounded-full" data-id="element-16">
              <BookOpen className="w-4 h-4 text-green-700 mr-1.5" data-id="element-17" />
              <span className="font-bold text-sm text-green-800" data-id="element-18">
                8 Modulos + 6 Bonos
              </span>
            </div>
          </div>

          <button onClick={scrollToOffer} className="w-full md:w-auto bg-green-700 hover:bg-green-800 text-white text-xl font-black py-4 px-8 rounded-full shadow-lg transform transition hover:scale-105 flex items-center justify-center mx-auto uppercase tracking-wider" data-id="element-19">
            Quiero dominar el mediocampo
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-20" />
          </button>
        </header>

        {/* PROBLEMS SECTION */}
        <section className="mb-12" data-id="element-21">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-gray-900" data-id="element-22">
            Jugar de pivote puede ser dificil
          </h3>
          <div className="space-y-3" data-id="element-23">
            {['Perder el balón en zonas peligrosas por la presión asfixiante del rival.', 'Quedar mal posicionado y dejar expuesta a tu línea defensiva en los contraataques.', 'Falta de aire para aguantar el ritmo de ida y vuelta los 90 minutos del partido.', 'No saber cómo perfilarse correctamente para recibir y tocar rápido a un toque.', 'Sufrir lesiones constantes por choques, malos giros y sobrecargas musculares.'].map((problem, i) => <div key={i} className="flex items-start bg-red-50 border border-red-200 border-l-4 border-l-red-500 rounded-xl p-4 shadow-sm" data-id="element-24">
                <AlertTriangle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-25" />
                <p className="text-red-900 text-base md:text-lg" data-id="element-26">{problem}</p>
              </div>)}
          </div>
        </section>

        {/* MODULES SECTION */}
        <section className="mb-12" data-id="element-27">
          <h3 className="text-xl md:text-2xl font-bold text-center mb-6 text-white bg-green-700 px-4 py-3 rounded-lg leading-snug" data-id="element-28">
            Para eso hemos preparado el manual del pivote moderno
          </h3>

          <div className="space-y-2" data-id="element-29">
            <Accordion title="🧠 TOMO 1 — EL ROL DEL PIVOTE: FUNDAMENTOS Y PERFIL" data-id="element-30">
              {`(48 páginas)
Capítulo 1. Introducción a la posición (6 pág.)
1.1 Qué es el "5" en el fútbol moderno
1.2 Evolución histórica: del marcador al organizador
1.3 El paradigma actual: el pivote como cerebro del equipo
1.4 Referencias del modelo moderno de pivote y qué representan táctica y físicamente

Capítulo 2. Perfiles del pivote (8 pág.)
2.1 El pivote defensivo puro (destructor)
2.2 El pivote organizador (constructor de juego)
2.3 El pivote box-to-box
2.4 El pivote mixto: el modelo más demandado en la actualidad
2.5 Autoevaluación: ¿qué tipo de "5" sos?

Capítulo 3. Cualidades físicas del pivote (7 pág.)
3.1 Resistencia aeróbica y capacidad de repetir esfuerzos
3.2 Fuerza funcional y duelos
3.3 Velocidad de reacción y aceleración corta
3.4 Movilidad de cadera y tobillo

Capítulo 4. Cualidades técnicas base (8 pág.)
4.1 Primer control orientado
4.2 Pase corto y pase largo de precisión
4.3 El giro con el cuerpo (media vuelta)
4.4 El "pivoteo" como recurso técnico central de la posición

Capítulo 5. Cualidades tácticas y mentales (8 pág.)
5.1 Anticipación y lectura de trayectorias
5.2 Comunicación con la línea defensiva
5.3 Gestión de la presión rival
5.4 Liderazgo silencioso: el pivote como referencia emocional del equipo

Capítulo 6. Autodiagnóstico y plan personal (6 pág.)
6.1 Test de autoevaluación física
6.2 Test de autoevaluación técnica
6.3 Cómo usar este manual según tu nivel (base, cantera, amateur, semiprofesional)

Capítulo 7. Introducción a los siguientes tomos (5 pág.)
7.1 Mapa de ruta del programa completo
7.2 Cómo integrar los 8 tomos en tu temporada`}
            </Accordion>

            <Accordion title="🛡️ TOMO 2 — LECTURA DE JUEGO Y POSICIONAMIENTO DEFENSIVO" data-id="element-31">
              {`(52 páginas)
Capítulo 1. Principios del posicionamiento (8 pág.)
1.1 La posición respecto al balón, al rival y a los compañeros
1.2 El triángulo defensivo con los centrales
1.3 Distancias de cobertura y basculación

Capítulo 2. Lectura de la jugada rival (10 pág.)
2.1 Anticipar el pase interior
2.2 Leer el desmarque del "10" rival
2.3 Detectar el cambio de orientación del juego
2.4 Señales corporales del rival que anticipan la acción

Capítulo 3. Marcaje y duelos individuales (9 pág.)
3.1 Marcaje al hombre en zona de tres cuartos
3.2 Duelos de espalda y protección del balón
3.3 Entradas limpias: técnica y timing
3.4 Gestión de tarjetas y decisiones de riesgo

Capítulo 4. Cobertura y equilibrio del equipo (8 pág.)
4.1 Cobertura de la espalda de los laterales
4.2 Reequilibrio tras pérdida de balón
4.3 El pivote como "escudo" ante contraataques

Capítulo 5. Presión y recuperación (9 pág.)
5.1 Presión orientada y presión de acompañamiento
5.2 Recuperación en campo rival vs. repliegue
5.3 Coordinación de la presión con el mediocentro compañero

Capítulo 6. Casos de estudio tácticos (8 pág.)
6.1 Análisis de situaciones de 2v1 y 3v2
6.2 Errores típicos de posicionamiento y cómo corregirlos
6.3 Ejercicios de vídeo-análisis personal (plantilla incluida)`}
            </Accordion>

            <Accordion title="🎯 TOMO 3 — SALIDA DE BALÓN Y CONSTRUCCIÓN DE JUEGO" data-id="element-32">
              {`(50 páginas)
Capítulo 1. El pivote como primer constructor (8 pág.)
1.1 Recepción entre líneas rivales
1.2 El giro de salida (media vuelta protegida)
1.3 Orientación del cuerpo antes de recibir

Capítulo 2. Pase corto de progresión (9 pág.)
2.1 Pase al central en apoyo
2.2 Pase al lateral en amplitud
2.3 Pase interior a los volantes

Capítulo 3. Pase largo y cambio de orientación (9 pág.)
3.1 El pase diagonal largo
3.2 El cambio de campo como recurso de descompresión
3.3 Precisión bajo presión: ejercicios progresivos

Capítulo 4. Juego bajo presión rival (8 pág.)
4.1 Salida en corto vs. salida directa: cuándo elegir cada una
4.2 Resolución en superioridad e inferioridad numérica
4.3 El "farol" y la finta de cuerpo para librarse de la presión

Capítulo 5. Combinaciones con el sistema (8 pág.)
5.1 Triangulaciones con central y lateral
5.2 Combinación con el "8" de banda a banda
5.3 Rotaciones de salida en el 4-3-3 y 4-2-3-1

Capítulo 6. Ejercicios integrados de construcción (8 pág.)
6.1 Circuitos de recepción-giro-pase
6.2 Rondos específicos para pivotes
6.3 Progresión de dificultad por nivel`}
            </Accordion>

            <Accordion title="💪 TOMO 4 — PREPARACIÓN FÍSICA: FUERZA Y POTENCIA" data-id="element-33">
              {`(55 páginas)
Capítulo 1. Bases del entrenamiento de fuerza para el pivote (7 pág.)
1.1 Por qué la fuerza es la cualidad física prioritaria del "5"
1.2 Fuerza máxima vs. fuerza funcional aplicada al duelo

Capítulo 2. Tren inferior (10 pág.)
2.1 Sentadilla y variantes (progresión por nivel)
2.2 Zancadas y trabajo unilateral
2.3 Ejercicios de cadera (peso muerto rumano, hip thrust)

Capítulo 3. Core y estabilidad central (9 pág.)
3.1 Anti-rotación (fundamental para el giro de pivote)
3.2 Anti-extensión y anti-flexión lateral
3.3 Circuitos de core aplicado al duelo físico

Capítulo 4. Potencia y explosividad (9 pág.)
4.1 Pliometría básica e intermedia
4.2 Ejercicios de salto y aceleración corta
4.3 Transferencia de la potencia al duelo aéreo y terrestre

Capítulo 5. Tren superior y protección del balón (8 pág.)
5.1 Fuerza de brazos y hombros para el cuerpo a cuerpo
5.2 Ejercicios para proteger el balón de espaldas al rival

Capítulo 6. Planificación semanal de fuerza (7 pág.)
6.1 Microciclo tipo en temporada
6.2 Microciclo tipo en pretemporada
6.3 Ajuste de cargas según partidos por semana

Capítulo 7. Test de control (5 pág.)
7.1 Test de fuerza y seguimiento de progreso (planillas)`}
            </Accordion>

            <Accordion title="🏥 TOMO 5 — PREVENCIÓN DE LESIONES Y RECUPERACIÓN" data-id="element-34">
              {`(46 páginas)
Capítulo 1. Lesiones típicas de la posición (8 pág.)
1.1 Sobrecarga lumbar por el giro constante
1.2 Lesiones de rodilla en el duelo y cambio de dirección
1.3 Lesiones de tobillo en la entrada

Capítulo 2. Prevención activa (10 pág.)
2.1 Rutina de activación pre-entrenamiento
2.2 Trabajo propioceptivo de tobillo y rodilla
2.3 Fortalecimiento de isquiotibiales (prevención de fibrilar)

Capítulo 3. Movilidad articular específica (8 pág.)
3.1 Movilidad de cadera para el giro de pivote
3.2 Movilidad torácica para el pase largo
3.3 Rutina diaria de movilidad (10 minutos)

Capítulo 4. Recuperación post-esfuerzo (9 pág.)
4.1 Recuperación activa vs. pasiva
4.2 Sueño y su impacto en el rendimiento del pivote
4.3 Nutrición básica de recuperación (sin sustitutos de asesoría profesional)

Capítulo 5. Vuelta a la actividad tras lesión leve (6 pág.)
5.1 Progresión segura de retorno al entrenamiento
5.2 Señales de alarma para consultar con un profesional

Capítulo 6. Rutinas descargables (5 pág.)
6.1 Checklist de prevención semanal
6.2 Planilla de seguimiento de molestias`}
            </Accordion>

            <Accordion title="♟️ TOMO 6 — TÁCTICA AVANZADA: SISTEMAS Y VARIANTES" data-id="element-35">
              {`(54 páginas)
Capítulo 1. El pivote en el 4-3-3 (8 pág.)
Capítulo 2. El pivote en el 4-2-3-1 (doble pivote) (8 pág.)
Capítulo 3. El pivote en el 3-5-2 / 5-3-2 (8 pág.)
Capítulo 4. El pivote en el 4-4-2 clásico (7 pág.)
Capítulo 5. Variantes de salida: línea de 3 con caída del pivote (8 pág.)
Capítulo 6. Rotaciones dinámicas y el pivote de área a área (8 pág.)
Capítulo 7. Ajustes tácticos según el rival (bloque alto vs. bloque bajo) (7 pág.)

(Nota de producción: este tomo funciona como base conceptual; el detalle visual y jugada por jugada de las 10 formaciones se desarrolla en profundidad en el Bono 3)`}
            </Accordion>

            <Accordion title="🧘‍♂️ TOMO 7 — PSICOLOGÍA Y LIDERAZGO DEL PIVOTE" data-id="element-36">
              {`(45 páginas)
Capítulo 1. El pivote como líder silencioso del equipo (8 pág.)
1.1 Liderazgo por el ejemplo vs. liderazgo verbal
1.2 Comunicación efectiva con la defensa

Capítulo 2. Gestión de la presión y el error (8 pág.)
2.1 Cómo recuperarse mentalmente de un error propio en la salida de balón
2.2 Rutinas de reseteo mental durante el partido

Capítulo 3. Concentración y toma de decisiones (8 pág.)
3.1 Toma de decisiones bajo fatiga
3.2 Ejercicios de visualización pre-partido

Capítulo 4. Relación con el cuerpo técnico y compañeros (7 pág.)
4.1 El pivote como enlace entre defensa y entrenador
4.2 Feedback constructivo a los centrales

Capítulo 5. Construcción de la identidad competitiva (8 pág.)
5.1 Rutinas de autoconfianza
5.2 Manejo de la crítica (redes, familia, entorno)

Capítulo 6. Plan de trabajo mental semanal (6 pág.)
6.1 Ejercicios prácticos para incorporar a la rutina de entrenamiento`}
            </Accordion>

            <Accordion title="📅 TOMO 8 — PLAN DE ENTRENAMIENTO INTEGRAL Y PERIODIZACIÓN" data-id="element-37">
              {`(58 páginas)
Capítulo 1. Cómo integrar los 7 tomos anteriores (6 pág.)
Capítulo 2. Periodización anual (10 pág.)
2.1 Pretemporada (bloques de fuerza y base aeróbica)
2.2 Temporada regular (mantenimiento y microciclos)
2.3 Fin de temporada y transición

Capítulo 3. Plan de 12 semanas (nivel base/cantera) (10 pág.)
Capítulo 4. Plan de 12 semanas (nivel amateur competitivo) (10 pág.)
Capítulo 5. Plan de 12 semanas (nivel semiprofesional) (10 pág.)

Capítulo 6. Ajuste del plan según posición dentro del sistema (6 pág.)
6.1 Pivote único vs. doble pivote: diferencias de carga

Capítulo 7. Seguimiento y planillas de control (6 pág.)
7.1 Planilla de seguimiento semanal
7.2 Indicadores de progreso técnico, físico y táctico`}
            </Accordion>
          </div>
        </section>

        {/* RANDOM REVIEWS */}
        <section className="mb-12" data-id="element-38">
          <div className="grid gap-4 md:grid-cols-3" data-id="element-39">
            {[{
            name: 'Pablo, Zaragoza',
            text: '¡Brutal! Muy completo y fácil de entender. Me cambió la forma de ver el campo.'
          }, {
            name: 'Sergio, Málaga',
            text: 'Lo mejor que he comprado para mejorar mi fútbol. Los ejercicios son top.'
          }, {
            name: 'Raúl, Alicante',
            text: 'Aplicable desde el primer día. 10/10. Mi entrenador notó la diferencia rápido.'
          }].map((review, i) => <div key={i} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-40">
                <div className="flex text-yellow-400 mb-2" data-id="element-41">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-42" />)}
                </div>
                <p className="text-gray-700 text-sm italic mb-2" data-id="element-43">
                  "{review.text}"
                </p>
                <p className="text-gray-500 text-xs font-bold" data-id="element-44">
                  - {review.name}
                </p>
              </div>)}
          </div>
        </section>

        {/* BONUSES SECTION */}
        <section className="mb-12" data-id="element-45">
          <div className="text-center mb-8" data-id="element-46">
            <h3 className="text-3xl md:text-4xl font-black text-green-700 uppercase tracking-widest" data-id="element-47">
              Llevate gratis HOY
            </h3>
            <p className="text-gray-600 mt-2" data-id="element-48">
              Solo por tiempo limitado con tu compra
            </p>
          </div>

          <div className="space-y-2" data-id="element-49">
            <Accordion title="🎁 BONO 1 — SISTEMA DE PASES INTEGRAL" previewImage="https://cdn.magicpatterns.com/uploads/bKBSRpgrrDyVRA6efEwzzs/Screenshot_2026-07-07_at_12.12.03_AM.png" data-id="element-50">
              {`Capítulo 1. Fundamentos técnicos del pase
1.1 Superficies de contacto y su uso según distancia
1.2 Postura corporal y equilibrio en el momento del pase

Capítulo 2. Pase corto
2.1 Pase raso al pie
2.2 Pase al espacio para compañero en movimiento
2.3 Pase de primera intención

Capítulo 3. Pase largo
3.1 Pase diagonal de cambio de orientación
3.2 Pase filtrado entre líneas
3.3 Balón dividido a espacio para banda

Capítulo 4. Pase bajo presión
4.1 Pase con rival encima (protección de apoyo)
4.2 Pase de primera bajo presión alta

Capítulo 5. Progresiones y combinaciones grupales
5.1 Rondos de pase específicos por posición
5.2 Circuitos de pase y movimiento (pase y me voy)

Capítulo 6. Plan de entrenamiento de pase (4 semanas)
6.1 Progresión diaria
6.2 Test de precisión y velocidad de pase`}
            </Accordion>

            <Accordion title="🎁 BONO 2 — SISTEMA DE TIROS LIBRES Y AL ARCO INTEGRAL" previewImage="https://cdn.magicpatterns.com/uploads/2yEaK6Hv9otrB4M1bu53XJ/Screenshot_2026-07-07_at_12.11.42_AM.png" data-id="element-51">
              {`Capítulo 1. Fundamentos del disparo
1.1 Tipos de contacto: empeine, interior, exterior
1.2 Postura de armado y equilibrio del cuerpo no dominante

Capítulo 2. Tiro de media y larga distancia
2.1 El disparo de pivote desde fuera del área (recurso ofensivo del "5" moderno)
2.2 Potencia vs. colocación

Capítulo 3. Tiros libres directos
3.1 Tiro libre con efecto (rosca)
3.2 Tiro libre raso con potencia
3.3 Definición de la barrera y el punto de impacto

Capítulo 4. Tiros libres indirectos y jugadas a balón parado
4.1 El pivote como ejecutor de la pared en tiros libres indirectos
4.2 Combinaciones de dos y tres jugadores

Capítulo 5. Definición dentro del área
5.1 Remate de cabeza en corners a favor
5.2 Segunda jugada y remate de rechace (rol característico del pivote)

Capítulo 6. Plan de entrenamiento de definición (4 semanas)
6.1 Rutina de repeticiones diarias
6.2 Test de precisión de tiro libre y remate`}
            </Accordion>

            <Accordion title="🎁 BONO 3 — EL ROL DEL '5' EN 10 FORMACIONES Y CÓMO JUGARLAS" previewImage="https://cdn.magicpatterns.com/uploads/qhCViLEhxdxZT33SHfAMMS/Screenshot_2026-07-07_at_12.12.36_AM.png" data-id="element-52">
              {`Formato visual con diagramas de campo
Introducción — Cómo leer los diagramas tácticos de este bono
4-3-3 — El pivote base entre dos interiores
4-2-3-1 — Doble pivote: reparto de funciones defensiva/organizadora
4-4-2 clásico — El pivote como único filtro ante la defensa
3-5-2 — El pivote entre los tres centrales en la salida
5-3-2 — Rol defensivo reforzado del pivote
4-1-4-1 — El pivote como "1" aislado: exigencia de cobertura total
4-3-1-2 — El pivote en apoyo al mediapunta
3-4-3 — El pivote como equilibrio ante amplitud de carrileros
4-4-1-1 — Variante de repliegue y transición rápida
Doble pivote asimétrico (4-2-3-1 variante moderna) — Un pivote de contención + un pivote de proyección
Cierre: cuadro comparativo — Exigencias físicas y tácticas del pivote según cada sistema`}
            </Accordion>

            <Accordion title="🎁 BONO 4 — VISUALES DE JUGADAS PREPARADAS" previewImage="https://cdn.magicpatterns.com/uploads/sR9iT3NWobuFCmjuA77rzB/Screenshot_2026-07-07_at_12.11.20_AM.png" data-id="element-53">
              {`Formato visual con diagramas de campo
Capítulo 1. Jugadas de salida desde el pivote
1.1 Salida en corto con apertura a central
1.2 Salida con tercer hombre (pivote-central-lateral)
1.3 Salida con caída del pivote entre centrales

Capítulo 2. Jugadas de pressing con participación del pivote
2.1 Presión orientada con cobertura del pivote
2.2 Trampa de pressing en banda con el pivote como cierre

Capítulo 3. Jugadas a balón parado ofensivas
3.1 Córner con bloqueo para el pivote
3.2 Tiro libre indirecto con pared del pivote
3.3 Saque de banda largo con el pivote como receptor

Capítulo 4. Jugadas a balón parado defensivas
4.1 Organización de marcas en córner en contra
4.2 Barrera y cobertura de segunda jugada`}
            </Accordion>

            <Accordion title="🎁 BONO 5 — EJERCICIOS PARA HACER SOLO EN CASA: HABILIDAD CON EL BALÓN (PIE)" previewImage="https://cdn.magicpatterns.com/uploads/8BFYj91p3dDZYBAJff8bQZ/Screenshot_2026-07-07_at_12.12.18_AM.png" data-id="element-54">
              {`Capítulo 1. Introducción al entrenamiento individual
1.1 Espacio mínimo necesario y materiales caseros

Capítulo 2. Control y primer toque
2.1 Control orientado contra pared
2.2 Control de pecho a pie (progresión)

Capítulo 3. Conducción y cambios de dirección
3.1 Circuito de conos caseros
3.2 Conducción con cambio de ritmo

Capítulo 4. Pase de precisión contra pared
4.1 Rutina de pase corto repetido
4.2 Rutina de pase a un objetivo (progresión de distancia)

Capítulo 5. Coordinación y toque rápido (juegos de pie)
5.1 Toques de mantenimiento (ambos pies)
5.2 Ejercicios de coordinación tipo "escalerita" sin escalera

Capítulo 6. Plan semanal de 20 minutos diarios
6.1 Rutina lunes a viernes
6.2 Planilla de autoseguimiento de progreso`}
            </Accordion>

            <Accordion title="🎁 BONO 6 — ENTRENAMIENTO DE 8 SEMANAS" previewImage="https://cdn.magicpatterns.com/uploads/p7LFW1oC6RnC3SXsT2SXEH/Screenshot_2026-07-07_at_12.13.03_AM.png" data-id="element-55">
              {`Capítulo 1. Introducción y estructura del programa
1.1 Objetivo del plan de 8 semanas: preparación integral aplicada
1.2 Cómo se combinan aquí lo físico, lo técnico y lo táctico de los tomos anteriores
1.3 Test inicial de nivel (física, técnica, referencia para medir progreso)

Capítulo 2. Semanas 1-2: Base y adaptación
2.1 Objetivo del bloque: acondicionamiento general y técnica de base
2.2 Sesiones día por día (física + técnica de pase y control)
2.3 Volumen e intensidad recomendados

Capítulo 3. Semanas 3-4: Desarrollo de fuerza y lectura de juego
3.1 Objetivo del bloque: fuerza funcional + posicionamiento defensivo
3.2 Sesiones día por día (fuerza tren inferior/core + ejercicios de anticipación)
3.3 Incorporación de rondos específicos de pivote

Capítulo 4. Semanas 5-6: Potencia y construcción de juego
4.1 Objetivo del bloque: explosividad + salida de balón bajo presión
4.2 Sesiones día por día (pliometría + circuitos de pase y giro)
4.3 Introducción de trabajo táctico según sistema (referencia al Tomo 6 y Bono 3)

Capítulo 5. Semanas 7-8: Integración y pico de rendimiento
5.1 Objetivo del bloque: integrar físico + técnico + táctico en situaciones de partido
5.2 Sesiones día por día (trabajo combinado de alta exigencia)
5.3 Descarga y puesta a punto para competencia

Capítulo 6. Seguimiento y cierre del programa
6.1 Test final de nivel y comparación con el test inicial
6.2 Planilla de seguimiento semanal (física, técnica, sensaciones)
6.3 Cómo continuar: transición hacia el Tomo 8 (periodización anual)`}
            </Accordion>
          </div>
        </section>

        {/* COMPARISON TABLE */}
        <section className="mb-12" data-id="element-56">
          <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-md" data-id="element-57">
            <div className="flex" data-id="element-58">
              <div className="w-1/2 p-4 md:p-6 bg-red-50 border-r border-gray-200" data-id="element-59">
                <h4 className="text-center font-bold text-red-600 mb-4 text-sm md:text-lg h-12 flex items-center justify-center" data-id="element-60">
                  Sin Manual del pivote moderno
                </h4>
                <ul className="space-y-3 text-xs md:text-sm text-gray-700" data-id="element-61">
                  <li className="flex items-start" data-id="element-62">
                    <XCircle className="w-4 h-4 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-63" />{' '}
                    Juegas por instinto, sin entender tu rol.
                  </li>
                  <li className="flex items-start" data-id="element-64">
                    <XCircle className="w-4 h-4 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-65" />{' '}
                    Pierdes balones por mala ubicación.
                  </li>
                  <li className="flex items-start" data-id="element-66">
                    <XCircle className="w-4 h-4 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-67" />{' '}
                    Te cansas rápido por correr mal la cancha.
                  </li>
                  <li className="flex items-start" data-id="element-68">
                    <XCircle className="w-4 h-4 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-69" />{' '}
                    Riesgo alto de lesiones por mala preparación.
                  </li>
                </ul>
              </div>
              <div className="w-1/2 p-4 md:p-6 bg-green-50" data-id="element-70">
                <h4 className="text-center font-bold text-green-700 mb-4 text-sm md:text-lg h-12 flex items-center justify-center" data-id="element-71">
                  Con Manual del pivote moderno
                </h4>
                <ul className="space-y-3 text-xs md:text-sm text-gray-700" data-id="element-72">
                  <li className="flex items-start" data-id="element-73">
                    <CheckCircle2 className="w-4 h-4 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-74" />{' '}
                    Entiendes la táctica como un profesional.
                  </li>
                  <li className="flex items-start" data-id="element-75">
                    <CheckCircle2 className="w-4 h-4 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-76" />{' '}
                    Siempre bien ubicado para recibir o cortar.
                  </li>
                  <li className="flex items-start" data-id="element-77">
                    <CheckCircle2 className="w-4 h-4 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-78" />{' '}
                    Físico preparado para aguantar 90 min a tope.
                  </li>
                  <li className="flex items-start" data-id="element-79">
                    <CheckCircle2 className="w-4 h-4 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-80" />{' '}
                    Rutinas de prevención para jugar sin dolor.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FINAL OFFER SECTION */}
        <section id="compra" className="scroll-mt-4 mb-12 bg-white p-6 md:p-10 rounded-2xl border-2 border-green-600 shadow-xl text-center relative overflow-hidden" data-id="element-81">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-green-600" data-id="element-82"></div>

          <div className="mb-6 bg-red-50 border border-red-200 p-4 rounded-lg" data-id="element-83">
            <p className="text-red-600 font-bold mb-2 flex items-center justify-center" data-id="element-84">
              <AlertTriangle className="w-5 h-5 mr-2" data-id="element-85" /> ¡ATENCIÓN! Cupos
              limitados
            </p>
            <div className="w-full bg-gray-200 rounded-full h-4 mb-2 overflow-hidden" data-id="element-86">
              <div className="bg-red-500 h-4 rounded-full w-[85%]" data-id="element-87"></div>
            </div>
            <p className="text-sm text-gray-700" data-id="element-88">
              Solo quedan <span className="font-bold text-gray-900" data-id="element-89">31</span> de
              200 cupos disponibles
            </p>
            <CountdownTimer data-id="element-90" />
          </div>

          <h3 className="text-3xl font-black mb-6 uppercase text-gray-900" data-id="element-91">
            Resumen de tu pedido
          </h3>

          <div className="text-left bg-gray-50 p-4 rounded-lg mb-6 border border-gray-200" data-id="element-92">
            <ul className="space-y-2 text-gray-700 font-medium" data-id="element-93">
              <li className="flex justify-between items-center" data-id="element-94">
                <span className="flex items-center" data-id="element-95">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-96" /> 8
                  Tomos del Manual del Pivote
                </span>
                <span className="text-gray-400 line-through" data-id="element-97">45€</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-98">
                <span className="flex items-center" data-id="element-99">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-100" /> Bono
                  1: Sistema de Pases
                </span>
                <span className="text-gray-400 line-through" data-id="element-101">15€</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-102">
                <span className="flex items-center" data-id="element-103">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-104" /> Bono
                  2: Tiros Libres
                </span>
                <span className="text-gray-400 line-through" data-id="element-105">15€</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-106">
                <span className="flex items-center" data-id="element-107">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-108" /> Bono
                  3: 10 Formaciones
                </span>
                <span className="text-gray-400 line-through" data-id="element-109">10€</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-110">
                <span className="flex items-center" data-id="element-111">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-112" /> Bono
                  4: Visuales de Jugadas
                </span>
                <span className="text-gray-400 line-through" data-id="element-113">10€</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-114">
                <span className="flex items-center" data-id="element-115">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-116" /> Bono
                  5: Ejercicios en Casa
                </span>
                <span className="text-gray-400 line-through" data-id="element-117">10€</span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-118">
                <span className="flex items-center" data-id="element-119">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-2" data-id="element-120" /> Bono
                  6: Entrenamiento 8 Semanas
                </span>
                <span className="text-gray-400 line-through" data-id="element-121">20€</span>
              </li>
              <li className="flex justify-between items-center pt-2 text-lg font-bold text-gray-900" data-id="element-122">
                <span data-id="element-123">Valor Total Real:</span>
                <span className="text-red-500 line-through" data-id="element-124">125€</span>
              </li>
            </ul>
          </div>

          <div className="mb-6" data-id="element-125">
            <p className="text-gray-500 text-lg mb-1" data-id="element-126">
              Precio Normal:{' '}
              <span className="line-through text-red-500" data-id="element-127">72€</span>
            </p>
            <p className="text-5xl font-black text-green-700" data-id="element-128">
              24€ <span className="text-sm text-gray-500 font-normal" data-id="element-129">EUR</span>
            </p>
            <p className="text-green-700 font-bold mt-2" data-id="element-130">
              ¡Oferta válida solo por hoy con los 6 bonos GRATIS!
            </p>
          </div>

          <button onClick={handleBuyClick} className="w-full bg-green-700 hover:bg-green-800 text-white text-xl font-black py-5 px-8 rounded-xl shadow-lg transform transition hover:scale-105 flex flex-col items-center justify-center uppercase tracking-wider" data-id="element-131">
            <span data-id="element-132">Quiero dominar el mediocampo</span>
            <span className="text-xs font-normal normal-case mt-1 opacity-90" data-id="element-133">
              Acceso inmediato • Pago 100% seguro
            </span>
          </button>

          <div className="flex justify-center items-center mt-4 text-gray-500 text-sm" data-id="element-134">
            <span className="flex items-center" data-id="element-135">
              <Zap className="w-4 h-4 mr-1" data-id="element-136" /> Acceso Inmediato
            </span>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="mb-12" data-id="element-137">
          <h3 className="text-2xl font-bold text-center mb-8 text-gray-900" data-id="element-138">
            Lo que dicen otros jugadores como tú
          </h3>
          <div className="grid gap-4 md:grid-cols-2" data-id="element-139">
            {[{
            name: 'Carlos M. (Madrid)',
            text: 'Desde que aplico lo del tomo 3, ya no me pongo nervioso cuando me presionan. Salgo jugando fácil.'
          }, {
            name: 'Javier G. (Valencia)',
            text: 'El plan de fuerza me cambió la vida. Ahora gano todos los choques y llego entero al final del partido.'
          }, {
            name: 'David R. (Sevilla)',
            text: 'Siempre jugué de 5 pero me faltaba orden. Este manual te explica exactamente dónde pararte.'
          }, {
            name: 'Alejandro T. (Barcelona)',
            text: 'Los bonos de pases y tiros libres valen oro. Mi precisión mejoró muchísimo en solo un mes.'
          }, {
            name: 'Miguel A. (Bilbao)',
            text: 'Lectura obligatoria si juegas en el medio. Te da herramientas de profesional adaptadas al fútbol amateur.'
          }].map((test, i) => <div key={i} className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-140">
                <div className="flex text-yellow-400 mb-3" data-id="element-141">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-142" />)}
                </div>
                <p className="text-gray-700 italic mb-3" data-id="element-143">"{test.text}"</p>
                <p className="text-gray-900 font-bold text-sm" data-id="element-144">{test.name}</p>
                <p className="text-gray-500 text-xs" data-id="element-145">Jugador Amateur</p>
              </div>)}
          </div>
        </section>

        {/* FAQ / OBJECTIONS */}
        <section className="mb-12" data-id="element-146">
          <h3 className="text-2xl font-bold text-center mb-6 text-gray-900" data-id="element-147">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-2" data-id="element-148">
            <Accordion title="¿Es para cualquier nivel?" data-id="element-149">
              Sí, el manual está diseñado con progresiones. Sirve tanto si
              juegas con amigos los fines de semana (nivel amateur) como si
              estás en canteras o equipos semiprofesionales.
            </Accordion>
            <Accordion title="¿Cómo recibo el manual y los bonos?" data-id="element-150">
              Al instante. Una vez realizado el pago, recibirás un correo
              electrónico automático con los enlaces para descargar todos los
              archivos en formato PDF, listos para leer en tu móvil, tablet o
              PC.
            </Accordion>
            <Accordion title="¿Sirve si juego fútbol 7 o fútbol sala?" data-id="element-151">
              Sí. Aunque los diagramas tácticos están enfocados en fútbol 11,
              los principios de posicionamiento, perfiles, fuerza, pases y
              lectura de juego son universales y te darán una ventaja enorme en
              cualquier formato.
            </Accordion>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="text-center border-t border-gray-200 pt-8 pb-12" data-id="element-152">
          <div className="flex items-center justify-center text-gray-600 mb-2" data-id="element-153">
            <Settings className="w-5 h-5 mr-2 text-green-700" data-id="element-154" />
            <span data-id="element-155">Soporte Técnico</span>
          </div>
          <a href="mailto:EbookDreamShop@gmail.com" className="text-green-700 hover:text-green-800 font-bold" data-id="element-156">
            EbookDreamShop@gmail.com
          </a>
          <p className="text-gray-400 text-xs mt-4" data-id="element-157">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </footer>
      </div>

      <SalesPopup data-id="element-158" />
    </div>;
}